export default __webpack_public_path__ + "static/media/upArrow.7753090c.svg";